// extracted by mini-css-extract-plugin
export default {"cls1":"ECffbIlxAQ2C3rRMKawQ","cls2":"MsJ2uPuk1u3T0dW2oqBm ECffbIlxAQ2C3rRMKawQ"};